export const MN_SELECTED_MUSEUM_ID_KEY = "mn-selected-museumId";
